import React from 'react'
import PropTypes from 'prop-types'
import Routes from 'commons/js/routes/routes'
import { isWebview } from '@elparking/utils'
import UrlParams from 'commons/js/util/UrlTo/UrlParams'
import LoaderBar from '../../ui/LoaderBar'

const Step1 = ({
    navigateTo,
    rates,
    isWebview,
}) => {
    const { startDate, endDate, isMutuaUser, age, filters, originPOI, destinationPOI } = rates
    const params = {
        start_date: startDate,
        end_date: endDate,
        isMutuaUser,
        age,
        share: (new UrlParams()).loadFromUrl().get('share'),
        vehicleType: filters && filters.vehicleType,
        isDifferentReturnLocation: originPOI && destinationPOI ? originPOI.id !== destinationPOI.id : false,
        idOriginPOI: originPOI && originPOI.id,
        pickUpInputSearch: (new UrlParams()).loadFromUrl().get('pickUpInputSearch'),
        returnPlaceInputSearch: (new UrlParams()).loadFromUrl().get('returnPlaceInputSearch'),
        titleOriginPOI: originPOI && originPOI.name,
        idDestinationPOI: destinationPOI && destinationPOI.id,
        titleDestinationPOI: destinationPOI && destinationPOI.name,
    }
    const url = isWebview ? Routes.rentalCarSitePathMobile(params) : Routes.rentalCarSitePath(params)
    navigateTo({ url })
    return (<LoaderBar />)
}

Step1.propTypes = {
    navigateTo: PropTypes.func,
    rates: PropTypes.object,
    isWebview,
}

Step1.defaultProps = {
    isWebview: isWebview(),
}

export default Step1
